import { DataTypes } from "../../../data/DataManager";
import { EMPTY_VALUE, FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { fromNumericCell, toNumericText } from "./numeric";

export const instrumentGTIN: FieldSchema = {
  grid: {
    displayed: true,
    order: 6,
    sortable: false,
    // Filtered as text despite being numeric: a GTIN is an identifier, so users look it up by
    // substring rather than by range or magnitude. Overrides the NUMBER filter that would
    // otherwise be derived from data.type below.
    filter: GridFilterTypes.TEXT,
  },
  name: "instrumentGTIN",
  data: {
    // Numeric for CSV and validation — a cell holds digits and non-numeric input is rejected.
    // It is stored as a string, which the transforms below bridge. The grid deliberately
    // filters it as text; see grid.filter above.
    type: DataTypes.NUMBER,
  },
  dataTransform: {
    fromCsv: { getter: ({ instrumentGTIN }) => fromNumericCell(instrumentGTIN) },
    toGraphql: { getter: ({ instrumentGTIN }) => toNumericText(instrumentGTIN) },
    toDb: { getter: ({ instrumentGTIN }) => toNumericText(instrumentGTIN) },
  },
  display: {
    displayed: true,
  },
  validation: {
    custom: {
      getter: ({ instrumentGTIN }) =>
        instrumentGTIN && !instrumentGTIN.toString().match(/^([1-9][0-9]*)?$/) ?
          "Enter a numeric value only" :
          EMPTY_VALUE,
    },
  },
  form: { label: "GTIN" },
};
